<template>
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.80762 9.5625H10.0576L10.1701 9.585C13.289 9.6455 16.0141 11.7075 16.9201 14.6925L17.3701 16.245H40.8376C42.9099 16.2544 44.8777 17.1563 46.2376 18.72C47.5937 20.2936 48.1938 22.3815 47.8801 24.435L46.5301 33.75C46.0805 37.3205 43.0636 40.0107 39.4651 40.05H26.2351C23.0745 40.0383 20.2911 37.9667 19.3726 34.9425L13.6801 15.75C13.2442 14.1034 11.7609 12.9517 10.0576 12.9375H7.80762C6.87564 12.9375 6.12012 12.182 6.12012 11.25C6.12012 10.318 6.87564 9.5625 7.80762 9.5625ZM22.6126 33.8625C23.0902 35.4645 24.5634 36.5625 26.2351 36.5625H39.4651C41.3274 36.5423 42.9044 35.1838 43.2001 33.345L44.5501 24.0075C44.734 22.9206 44.4342 21.8076 43.7294 20.9601C43.0245 20.1125 41.9848 19.6149 40.8826 19.5975H18.3826L22.6126 33.8625Z"
      fill="#FFDD00"
    />
    <path
      d="M25.7176 42.75C24.475 42.75 23.4676 43.7574 23.4676 45C23.4676 46.2426 24.475 47.25 25.7176 47.25C26.9603 47.25 27.9676 46.2426 27.9676 45C27.9676 43.7574 26.9603 42.75 25.7176 42.75Z"
      fill="#FFDD00"
    />
    <path
      d="M39.2176 42.75C37.975 42.75 36.9676 43.7574 36.9676 45C36.9676 46.2426 37.975 47.25 39.2176 47.25C40.4603 47.25 41.4676 46.2426 41.4676 45C41.4676 43.7574 40.4603 42.75 39.2176 42.75Z"
      fill="#FFDD00"
    />
  </svg>
</template>